var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-row',{attrs:{"label":_vm.title,"is-vertical-splitted":false}},[_c('form-section-question',{attrs:{"slot":"question"},slot:"question"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.subtitle)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }